import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SettingsShell from 'screens/Settings/components/wrappers/SettingsShell';
import { Divider, Message } from 'semantic';
import { currentUserCanAccess } from 'utils/roles';
import AccountBillingForm from './BillingAndPlans.form';
import FormHeader from 'screens/Settings/components/atoms/FormHeader';
import { useEnabledPaymentMethods } from 'contexts/enabledPaymentMethods';
import AccountBillingFormV2 from './BillingAndPlansV2.form';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useUser } from 'contexts/user';

export default function AccountBilling() {
  const { t } = useTranslation();

  const cannotReadBillingInformation = !currentUserCanAccess(
    'accounts-billing',
    'read'
  );

  const cannotEditBillingInformation = !currentUserCanAccess(
    'accounts-billing',
    'write'
  );

  const queryClient = useMemo(() => {
    return new QueryClient();
  }, []);
  useEffect(() => () => queryClient.clear(), []);

  if (cannotReadBillingInformation) {
    return (
      <SettingsShell>
        <FormHeader
          size="large"
          disabled={cannotEditBillingInformation}
          pb={5}
          pt={5}
          text={t(
            'settings.organization.billing.title',
            'Organization Billing'
          )}
        />
        <Divider />
        <Message warning>
          {t(
            'access.cannotViewBillingInformation',
            'You do not have sufficient permissions to view billing information.'
          )}
        </Message>
      </SettingsShell>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <SettingsShell>
        <AccountBillingPlanFormContainer />
      </SettingsShell>
    </QueryClientProvider>
  );
}

const AccountBillingPlanFormContainer = () => {
  const { enabledPaymentMethods } = useEnabledPaymentMethods();
  const { provider } = useUser();

  if (!provider?.enablePSPIntegrationsV2) {
    return <AccountBillingForm />;
  }

  return (
    <>
      {enabledPaymentMethods.length === 0 && <AccountBillingForm />}
      {enabledPaymentMethods.length > 0 && <AccountBillingFormV2 />}
    </>
  );
};
